import { v4 as uuidv4 } from 'uuid';

import APP_CONSTANTS from '@/config/constants';
import { databaseService } from '@/services/databaseService';
import {
  getSyncClientBuild,
  syncCanaryFeatureDecisionStore,
} from '@/services/sync/SyncCanaryFeatureService';
import {
  ChecklistSnapshotCreationService,
  type ChecklistSnapshotFeatureProvider,
} from './ChecklistSnapshotCreationService';

const snapshotFeatureProvider: ChecklistSnapshotFeatureProvider = {
  isEnabled({ companyId, clientBuild, featureKey }) {
    return syncCanaryFeatureDecisionStore.get({
      companyId,
      featureKey,
      clientBuild,
    });
  },
};

export const checklistSnapshotCreationService = new ChecklistSnapshotCreationService({
  database: databaseService,
  featureProvider: snapshotFeatureProvider,
  tables: {
    checklists: APP_CONSTANTS.DATABASE.TABLES.GUINCHO_CHECKLISTS.NAME,
    templateFields: APP_CONSTANTS.DATABASE.TABLES.GUINCHO_CAMPOS_TEMPLATE.NAME,
    templateSchemaVersions: APP_CONSTANTS.DATABASE.TABLES.GUINCHO_TEMPLATE_SCHEMA_VERSIONS.NAME,
    snapshots: APP_CONSTANTS.DATABASE.TABLES.GUINCHO_CHECKLIST_SNAPSHOTS.NAME,
    snapshotFields: APP_CONSTANTS.DATABASE.TABLES.GUINCHO_CHECKLIST_SNAPSHOT_FIELDS.NAME,
  },
  createId: uuidv4,
  now: () => new Date(),
});

export const getChecklistSnapshotCreationClientBuild = getSyncClientBuild;
